import { StepIds, StepStatus } from 'helpers/enums/Assembleia';
import { ReactNode, useCallback, useReducer } from 'react';
import { RegisterContext, INITIAL_STATE } from '.';
import { EventReducer } from './reducer';
import { RegisterContextActions } from './RegisterContextActions';

interface IProps {
  children: ReactNode;
}

export const RegisterContextProvider = ({ children }: IProps) => {
  const [state, dispatch] = useReducer(EventReducer, INITIAL_STATE);

  const setStepCompleted = useCallback(
    (payload: { step: string; completed: boolean }[]) => {
      dispatch({
        type: RegisterContextActions.SET_STEP_COMPLETED,
        payload: payload,
      });
    },
    [dispatch]
  );

  const setStepId = useCallback(
    (payload: StepIds) => {
      dispatch({
        type: RegisterContextActions.SET_STEP_ID,
        payload,
      });
    },
    [dispatch]
  );
  const setStepStatus = useCallback(
    (payload: StepStatus) => {
      dispatch({
        type: RegisterContextActions.SET_STATUS,
        payload,
      });
    },
    [dispatch]
  );

  const dataStepSetFilter = useCallback(
    (payload: any) => {
      dispatch({
        type: RegisterContextActions.DATA_FILTER_SET,
        payload: payload,
      });
    },
    [dispatch]
  );

  const dataStepSetFilterOld = useCallback(
    (payload: any) => {
      dispatch({
        type: RegisterContextActions.DATA_FILTER_SET_OLD,
        payload: payload,
      });
    },
    [dispatch]
  );

  const entitiesStepSetFilter = useCallback(
    (payload: any) => {
      dispatch({
        type: RegisterContextActions.ENTITIES_FILTER_SET,
        payload: payload,
      });
    },
    [dispatch]
  );

  const localStepSetFilter = useCallback(
    (payload: any) => {
      dispatch({
        type: RegisterContextActions.LOCAL_FILTER_SET,
        payload: payload,
      });
    },
    [dispatch]
  );

  const localStepSetFilterOld = useCallback(
    (payload: any) => {
      dispatch({
        type: RegisterContextActions.LOCAL_FILTER_SET_OLD,
        payload: payload,
      });
    },
    [dispatch]
  );

  const surveyStepSetData = useCallback(
    (payload: any) => {
      dispatch({
        type: RegisterContextActions.SURVEY_FILTER_SET,
        payload: payload,
      });
    },
    [dispatch]
  );

  const surveyStepSetDataOld = useCallback(
    (payload: any) => {
      dispatch({
        type: RegisterContextActions.SURVEY_FILTER_SET_OLD,
        payload: payload,
      });
    },
    [dispatch]
  );

  const changeState = useCallback(
    (type: RegisterContextActions, payload: any) => {
      dispatch({
        type: type,
        payload: payload,
      });
    },
    [dispatch]
  );

  return (
    <RegisterContext.Provider
      value={{
        state,
        setStepId,
        setStepCompleted,
        setStepStatus,
        dataStepSetFilter,
        dataStepSetFilterOld,
        entitiesStepSetFilter,
        localStepSetFilter,
        localStepSetFilterOld,
        surveyStepSetFilter: surveyStepSetData,
        surveyStepSetFilterOld: surveyStepSetDataOld,
        changeState,
      }}
    >
      {children}
    </RegisterContext.Provider>
  );
};
